import React from "react"
import PropTypes from "prop-types"
import { HeadingTwo, Text, Container, Box, Stack } from "datastory-shared/ui"
import { useTranslation } from "datastory-shared/utils/i18n"
import { NewsletterSignup } from "datastory-shared/sections"

export const SerivceLayout = ({ children, isEmbedded, isViewportLocked }) => {
  const { t } = useTranslation()

  return (
    <>
      {isViewportLocked ? <Box height="100%">{children}</Box> : children}
      {!isEmbedded && !isViewportLocked && (
        <>
          <Container mb="7rem" mt={["2.5rem", "5rem"]}>
            <Stack alignItems="center">
              <Box w={["100%", "100%", "75%", "50%"]} textAlign="center">
                <HeadingTwo as="h1">
                  {t("og_c:newsletter_newsletter")}
                </HeadingTwo>
                <Text mt="0.5rem" muted>
                  {t("og_c:newsletter_intro")}
                </Text>
                <Stack mt="2.5rem" px={[0, 0, 0, "lg"]}>
                  <Box display={["none", "block"]}>
                    <NewsletterSignup tags={["Data story page"]} />
                  </Box>
                  <Box display={["block", "none"]}>
                    <NewsletterSignup tags={["Data story page"]} size="lg" />
                  </Box>
                </Stack>
              </Box>
            </Stack>
          </Container>
        </>
      )}
    </>
  )
}

SerivceLayout.propTypes = {
  children: PropTypes.node,
  service: PropTypes.object,
  isEmbedded: PropTypes.bool,
  isViewportLocked: PropTypes.bool,
  related: PropTypes.array,
}
